export default "__VITE_ASSET__BI8p9sz4__"